import { useState } from "react";
import Left from "./Left";
import Confetti from "../components/Confetti";

export default function Layout({ children }) {
  const [showMenu, setShowMenu] = useState(false);

  const handleCloseMenu = () => setShowMenu(false);

  return (
    <div style={{ display: "flex", minHeight: "100vh", position: "relative" }}>
      <Confetti />
      <button className="hamburger-button" onClick={() => setShowMenu(!showMenu)}>
        ☰
      </button>
      <div className={`left-wrapper ${showMenu ? "show" : ""}`}>
        <Left onClickLink={handleCloseMenu} />
      </div>
      <main style={{ flexGrow: 1, padding: "40px 20px" }}>{children}</main>
    </div>
  );
}
